import { useCallback } from 'react';
import { useRouter } from 'next/router';
import { UrlObject } from 'url';

import { isDev } from '@restworld/utils-common';

export const useV2Router = () => {
  const router = useRouter();
  const push = useCallback(
    (url: UrlObject | string, as?: UrlObject | string, options?: Parameters<typeof router.push>[2]) => {
      try {
        if (typeof url === 'string') {
          if (!url.startsWith('/v2')) {
            url = `/v2${url}`;
          }
        }
        router.push(url, as, options);
      } catch (error) {
        console.error('Failed to push to router:', error);
      }
    },
    [router]
  );

  if (isDev) return router;
  return { ...router, push };
};
